// --------- BEGIN RUNBOX LICENSE ---------
// Copyright (C) 2016-2019 Runbox Solutions AS (runbox.com).
//
// This file is part of Runbox 7.
//
// Runbox 7 is free software: You can redistribute it and/or modify it
// under the terms of the GNU General Public License as published by the
// Free Software Foundation, either version 3 of the License, or (at your
// option) any later version.
//
// Runbox 7 is distributed in the hope that it will be useful, but
// WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the GNU
// General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with Runbox 7. If not, see <https://www.gnu.org/licenses/>.
// ---------- END RUNBOX LICENSE ----------

import { RunboxWebmailAPI } from './rmmapi/rbwebmail';
import { Injectable } from '@angular/core';
import { AsyncSubject, firstValueFrom, ReplaySubject } from 'rxjs';

@Injectable()
export class StorageService {
    uid = new AsyncSubject<number>();
    keySubjects: { [key: string]: ReplaySubject<any> } = {};

    constructor(
        rmmapi: RunboxWebmailAPI,
    ) {
        rmmapi.me.subscribe(me => {
            this.uid.next(me.uid);
            this.uid.complete();
        });
    }

    private async userKey(key: string): Promise<string> {
        const uid = await firstValueFrom(this.uid);
        return `${uid}:${key}`;
    }

    async get(key: string): Promise<any> {
        const value = localStorage.getItem(await this.userKey(key));
        return value ? JSON.parse(value) : undefined;
    }

    getSubject(key: string): ReplaySubject<any> {
        if (!this.keySubjects[key]) {
            this.keySubjects[key] = new ReplaySubject<any>(1);
            this.get(key).then(value => this.keySubjects[key].next(value));
        }
        return this.keySubjects[key];
    }

    async set(key: string, value: any): Promise<void> {
        if (value === undefined) {
            localStorage.removeItem(await this.userKey(key));
        } else {
            const valueStr = JSON.stringify(value);
            localStorage.setItem(await this.userKey(key), valueStr);
        }
        const subject = this.keySubjects[key];
        if (subject) {
            subject.next(value);
        }
    }
}
